import { render, staticRenderFns } from "./MudarStatus.vue?vue&type=template&id=4ba9efba"
import script from "./MudarStatus.vue?vue&type=script&lang=ts"
export * from "./MudarStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports